import { gql } from "apollo-boost";

export const USER_MERGE = gql`
  mutation MutateUser(
    $userId: Int
    $userName: String
    $password: String
    $passwordResetcode: String
    $photo: String
    $role: String
    $userEmail: String
    $birthDate: Date
    $gender: String
    $state: String
    $country: String
    $language: String
    $googleId: String
    $facebookId: String
    $updateSource: String!
  ) {
    userMerge(
      userData: {
        userId: $userId
        userName: $userName
        password: $password
        passwordResetcode: $passwordResetcode
        photo: $photo
        role: $role
        userEmail: $userEmail
        birthDate: $birthDate
        gender: $gender
        state: $state
        country: $country
        language: $language
        googleId: $googleId
        facebookId: $facebookId
        updateSource: $updateSource
      }
    ) {
      node {
        userId
        userName
        password
        passwordResetcode
        photo
        role
        userEmail
        createDate
        birthDate
        gender
        state
        country
        language
        googleId
        facebookId
        updateSource
      }
    }
  }
`;

export const USER_DELETE = gql`
  mutation userDelete($userId: Int!) {
    userDelete(userId: $userId) {
      status
    }
  }
`;

export const SIGN_IN_USER = gql`
  mutation signInUser(
    $userId: Int
    $userEmail: String
    $password: String
    $googleId: String
    $facebookId: String
  ) {
    signInUser(
      userData: {
        userId: $userId
        userEmail: $userEmail
        password: $password
        googleId: $googleId
        facebookId: $facebookId
      }
    ) {
      userDetails {
        userId
        userName
        userEmail
        password
        accessToken
        refreshToken
        message
      }
    }
  }
`;

export const GET_CURRENT_USER = gql`
  mutation getCurrentUser {
    getCurrentUser {
      userEmail
      userId
      userName
      photo
      role
      createDate
      birthDate
      gender
      state
      country
      language
      googleId
      facebookId
    }
  }
`;
